import StoreView from '@/views/StoreView.js'
import ShareView from '@/views/ShareView.js'
import FeedView from '@/views/FeedView.js'
import FavoritesView from '@/views/FavoritesView.js'
import PostView from '@/views/PostView.js'
import ReportsView from '@/views/ReportsView.js'
import MeetingLivestreamView from '@/views/MeetingLivestreamView.js'

export const VIEWS = Object.entries({
  favoritesView: FavoritesView,
  feedView: FeedView,
  meetingLivestreamView: MeetingLivestreamView,
  postView: PostView,
  reportsView: ReportsView,
  shareView: ShareView,
  storeView: StoreView,
})
